// Currency formatting utilities for GBP
export const formatGBP = (pence: number): string => {
  return `£${(pence / 100).toFixed(2)}`;
};

export const penceToGBP = (pence: number): number => {
  return pence / 100;
};

export const gbpToPence = (gbp: number): number => {
  return Math.round(gbp * 100);
}; 